import React from "react";
import styled from "styled-components";

function Tech({ color, icon, name, type, useCase }) {
  return (
    <Container>
      <Head color={color}>{icon}</Head>
      <Column>
        <h4>name</h4>
        <p>{name}</p>
      </Column>
      <Column>
        <h4>type</h4>
        <p>{type}</p>
      </Column>
      <Column>
        <h4>use case</h4>
        <p>{useCase}</p>
      </Column>
    </Container>
  );
}

export default Tech;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 90px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  overflow: hidden;
  margin: 1rem 0px;

  @media (max-width: 850px) {
    flex-direction: column;
    height: auto;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

const Head = styled.div`
  height: 100%;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.color};

  @media (max-width: 850px) {
    height: 50px;
    width: 100%;
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 20px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);

  h4 {
    margin-bottom: 5px;
  }

  p {
    font-size: 1.1rem;
  }

  @media (max-width: 850px) {
    height: 50px;
    width: 100%;
    flex-shrink: 0;
    box-sizing: content-box;
    padding: 1rem;
  }
`;
